import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';  // needed by ToasterService
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms'; // <-- NgModel lives here
import { HttpClientModule } from '@angular/common/http';
import { MatDialogModule } from '@angular/material/dialog';

// 3rd party
import { LocalStorageModule } from 'angular-2-local-storage';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { ToasterModule, ToasterService } from 'angular2-toaster';
import { AngularDateTimePickerModule } from 'angular2-datetimepicker';  // possible alternate - npm i @ngui/datetime-picker


// sms
import { AppComponent } from './app.component';
import { SmsPageComponent } from './pages/sms-page/sms-page.component';
import { AirportWebService } from './airport-web-service/airport-web-service';
import { DesktopService } from './desktop-service/desktop-service';
import { RequestEmailDialogComponent } from './request-email-dialog/request-email-dialog.component';


@NgModule({
  declarations: [
    AppComponent,
    SmsPageComponent,
    RequestEmailDialogComponent
  ],

  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    LocalStorageModule.withConfig({storageType: 'localStorage'}),
    DeviceDetectorModule.forRoot(),
    ToasterModule.forRoot(),
    MatDialogModule,
    AngularDateTimePickerModule
  ],
  entryComponents: [ 
    RequestEmailDialogComponent 
  ],
  exports: [
    SmsPageComponent
  ],
  providers: [ AirportWebService, SmsPageComponent, DesktopService ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }
